<template>
    <div class="component-button">
      <div>
        <el-tabs class="header" :stretch="true">
          <el-tab-pane label="子表属性" :autofocus="true"></el-tab-pane>
        </el-tabs>
      </div>
       <div class="panel-children-table">
         <el-form :model="children" :inline="true" class="form-children" :rules="rules" ref='ruleForm'>
           <el-form-item label="子表名称" prop="name"><el-input v-model="children.name"></el-input></el-form-item>
           <el-form-item label="子表来源" prop="childrenReportId">
             <public-combobox v-model="children.childrenReportId" :options="reportTables" @change='changeChildrenTableColumns' :placeholder="'子表'" :clearable="false"></public-combobox>
            </el-form-item>
            <el-form-item label="子表字段" prop="childrenReportColumnId">
              <public-combobox v-model="children.childrenReportColumnId" :options="childrenColumns" :placeholder="'子表字段'" :clearable="false"></public-combobox>
            </el-form-item>
             <el-form-item label="主表字段" prop="referenceReportColumnId">
               <public-combobox v-model="children.referenceReportColumnId" :options="getMainReportColumns" :placeholder="'主表字段'" :clearable="false"></public-combobox>
            </el-form-item>
            <el-form-item label="板式设计" prop="type">
              <el-select v-model="children.type" placeholder="请选择">
                 <el-option label="上下分栏" value="splice"></el-option>
                 <el-option label="弹窗报表" value="dialog"></el-option>
                <el-option label="行内展开" value="expand"></el-option>
              </el-select>
            </el-form-item>
         </el-form>
      </div>
      <div class="buttons">
        <el-button type="primary" @click="saveAttr">保存</el-button>
        <el-button @click="closeAttr">取消</el-button>
      </div>
    </div>
</template>

<script>
import cache from '../../public/cache'
import publicCombobox from '@/components/public/public-combobox.vue'

export default {
  name: 'ChildrenTablePanel',
  inject: ['reportService', 'needLoad'],
  components: {publicCombobox},
  data () {
    let id = this.reportService.options.leftPanel.id
    const children = this.$_.cloneDeep(this.reportService.report.children.find(m => m.id === id))
    return {
      children: children,
      reportTables: [],
      childrenColumns: [],
      rules: {
        name: [
          { required: true, message: '请输入子表名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择报表板式', trigger: 'change' }
        ],
        childrenReportId: [
          { required: true, message: '请选择子表', trigger: 'change' }
        ],
        childrenReportColumnId: [
          { required: true, message: '请选择子表字段', trigger: 'change' }
        ],
        referenceReportColumnId: [
          { required: true, message: '请选择主表字段', trigger: 'change' }
        ]
      },
      childrenNeedLoad: this.needLoad.value
    }
  },
  mounted () {
    this.loadReportTables()
    this.getChildrenReportColumns(this.children.childrenReportId)
  },
  methods: {
    loadReportTables () {
      this.$axios.get('/report-api/report/definition/reports').then(({data}) => {
        this.$set(this, 'reportTables', data)
      })
    },
    changeChildrenTableColumns (val) {
      this.getChildrenReportColumns(val)
      this.children.childrenReportColumnId = ''
    },
    getChildrenReportColumns (val) {
      if (val) {
        cache.getDateWithNoparma(`/report-api/report/definition/${val}?type=run`)
          .then(data => {
            this.childrenColumns = data.columns
          })
      }
    },
    saveAttr () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.children.childrenReportId && this.children.childrenReportColumnId && this.children.referenceReportColumnId) {
            this.reportService.createOrUpdate(this.children)
          }
          this.closeAttr()
        } else {
          return false
        }
      })
    },
    closeAttr () {
      this.reportService.closePanel()
    }
  },
  computed: {
    getMainReportColumns () {
      return this.reportService.report.columns.map(m => {
        return {
          name: m.name,
          id: m.expressionText,
          pinyinName: m.pinyinName,
          pinyinFirstChar: m.pinyinFirstChar
        }
      })
    },
    getNeedLoad () {
      return this.needLoad.value
    }
  },
  watch: {
    getNeedLoad: {
      handler (val) {
        if (val > 0) {
          this.loadReportTables()
        }
      },
      deep: true,
      immediate: true
    },
    'reportService.options.leftPanel.id': {
      handler (val) {
        this.children = this.$_.cloneDeep(this.reportService.report.children.find(m => m.id === val))
        this.$nextTick(() => {
          this.loadReportTables()
          this.getChildrenReportColumns(this.children.childrenReportId)
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.component-button {
  .header {
    .el-tabs__nav-wrap {
      background-color: #ebf6ff;
    }
  }
  .panel-children-table {
    height: 80%;
    padding-left: 26px;
    padding-right: 27px;
    margin-top: -15px;
    overflow: hidden;
    overflow-y: auto;
    form {
      >.el-row {
        >div {
          margin-top: 8px;
        }
        .el-switch {
          float: right;
          top:2px;
        }
      }
      .el-form-item {
        .el-form-item__content {
          text-align: right;
          input.el-input__inner{
            height: 28px;
            line-height: 28px;
            border: 1px solid #c2c3c4;
          }
        }
      }
      label.el-form-item__label {
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        padding-bottom: 0;
      }
      .el-date-editor {
        width: 100%;
      }
    }
    .el-form-item {
      margin-bottom: 6px;
    }
  }
  .buttons {
    height: 10%;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    background: #fff;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    button{
      width: 72px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/report/design/children-table-panel.vue